import { ReactNode } from 'react'

import styles from './SettingsCard.module.css'

interface SettingsCardProps {
  children: ReactNode
  className?: string
}

interface SettingsCardHeaderProps {
  children: ReactNode
  action?: ReactNode
  className?: string
}

interface SettingsCardDescriptionProps {
  children: ReactNode
  className?: string
}

interface SettingsCardBodyProps {
  children: ReactNode
  className?: string
}

const SettingsCardRoot = ({ children, className }: SettingsCardProps) => {
  return <div className={`${styles.card} ${className ?? ''}`}>{children}</div>
}

const SettingsCardHeader = ({
  children,
  action,
  className,
}: SettingsCardHeaderProps) => {
  return (
    <div className={`${styles.header} ${className ?? ''}`}>
      {children}
      {action}
    </div>
  )
}

const SettingsCardDescription = ({
  children,
  className,
}: SettingsCardDescriptionProps) => {
  return (
    <div className={`${styles.description} ${className ?? ''}`}>{children}</div>
  )
}

const SettingsCardBody = ({ children, className }: SettingsCardBodyProps) => {
  return <div className={`${className ?? ''}`}>{children}</div>
}

export const SettingsCard = Object.assign(SettingsCardRoot, {
  Header: SettingsCardHeader,
  Description: SettingsCardDescription,
  Body: SettingsCardBody,
})
